import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';

// Service Section
import { dashboardlandingpageservice } from '../../_services/dashboardservice/dash-board.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { DashboardExchangerateComponent } from '../dashboard-exchangerate/dashboard-exchangerate.component';
import { User } from '../../models/user/user';
// Cart Type
import { CartServiceService } from '../../_services/dashboardservice/cart/cart-service.service';
import { currentcartdetail } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { AuthService } from '../../_services/userservice/auth.service';

import { SendMoneyDetail, SendMoneySteps, SendMoneyProgramDetail } from '../../models/sendmoney/sendmoney';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';

import { RepeatorderDashboardlistComponent } from '../../repeatorder/repeatorderlist-dashboard/repeatorderlist-dashBoard.component';
import { DashboardSupersendComponent } from '../dashboard-supersend/dashboard-supersend.component';
import { AppSettings, enumStatusCodeList } from 'app/sharedcomponents/_common/constants/app.constants';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { TranslateService } from 'ng2-translate/ng2-translate';
import * as written from 'written-number';
import { UserStateService } from '../../_services/userservice/userstateservice';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { DoNotRefreshAndBackComponent } from '../../sharedcomponents/_directive/do-not-refresh-and-back/do-not-refresh-and-back.component';
import { UserGioLocation } from '../../models/user/usergioLocation';

declare var ___MobileAgent___: any;

@Component({
  moduleId: module.id,
  selector: 'app-dash-board',
  templateUrl: './dash-board.component.html',
  styleUrls: ['./dash-board.component.css'],
  providers: [dashboardlandingpageservice, Modal, CartServiceService, AlertService, AuthService]
})
export class DashBoardComponent implements OnInit {
  repeatOrderLength: number;
  curcarddetailresponsemodel: currentcartdetail;
  sendMoneyDetail: SendMoneyDetail;
  //userDetail: usercommonattribute;
  userGioLocation: UserGioLocation;
  constructor(
    private router: Router,
    public utilserv: utilityService,
    private cartservice: CartServiceService,
    private sendMoneyService: SendMoneyService,
    private modal: Modal,
    public geoloc: geolocation,
    private translate: TranslateService,
    private userStateService: UserStateService,
    private auth: AuthService,
    private vcRef: ViewContainerRef
  ) {
    this.curcarddetailresponsemodel = new currentcartdetail();
    // this.userDetail = new usercommonattribute();
    // const userStateServiceSub = this.userStateService.getcurrentUserDetailData().subscribe(data => {
    //   this.userDetail = data;
    // });

    this.initAppData();
    this.getcarttype(this.curcarddetailresponsemodel);
  }

  ngOnInit() {
     //this.userDetails();
  }

  supersendClick() {
    let _self = this;
    const modalData: any = {};
    modalData.srcAmount = 100;
    modalData.srcAmountIsDisabled = false;
    modalData.page = 'dashboard';
    modalData.LocationId = '';
    modalData.CountrySupportedCurrencyCodesTo = '';
    modalData.ProgramId = 0;
    modalData.DeliveryMethod = 1;
    this.userStateService.getcurrentUserDetailData().subscribe(data => {
      modalData.CountryCodeTo = data.countryPreference;
    });
    modalData.DeliveryMethod = 1;
    this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(
      data => {
        if (data == undefined) {
          return;
        }
        if (data == true) {
          return _self.modal.open(DashboardSupersendComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              if (modalData.next === 'yes') {
                if (
                  localStorage.isShowDoNotRefreshAndBack == false ||
                  localStorage.isShowDoNotRefreshAndBack == undefined ||
                  localStorage.isShowDoNotRefreshAndBack == 'false' ||
                  localStorage.isShowDoNotRefreshAndBack == 'undefined'
                ) {
                  modalData.Title = _self.translate.instant('Common_lblInfo').toString();
                  modalData.Message = _self.translate.instant('Common_lblDoNotRefreshAndBack').toString();
                  modalData.Message1 = _self.translate.instant('Common_lblDoNotRefreshAndBackCheck').toString();
                  return _self.modal.open(DoNotRefreshAndBackComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                    obj.onDestroy.subscribe(data => {
                      localStorage.isShowDoNotRefreshAndBack = modalData.isShowDoNotRefreshAndBack;
                      _self.sendMoneyDetail = new SendMoneyDetail();
                      _self.sendMoneyDetail.isData = true;
                      _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                      _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                      _self.router.navigate(['/sendmoney']);
                      return;
                    });
                  });
                } else {
                  _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                  _self.sendMoneyDetail = new SendMoneyDetail();
                  _self.sendMoneyDetail.isData = true;
                  _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                  _self.router.navigate(['/sendmoney']);
                  return;
                }
              }
            });
          });
        } else {
          modalData.Action = this.translate.instant('Common_lblOk');
          modalData.Title = this.translate.instant('Common_lblInfo').toString();
          modalData.Message = this.translate.instant('Common_lblLocationValidate').toString();
          this.modal.overlay.defaultViewContainer = this.vcRef;
          return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(data => {
              return _self.modal.open(DashboardSupersendComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                obj.onDestroy.subscribe(data => {
                  if (modalData.next === 'yes') {
                    if (
                      localStorage.isShowDoNotRefreshAndBack == false ||
                      localStorage.isShowDoNotRefreshAndBack == undefined ||
                      localStorage.isShowDoNotRefreshAndBack == 'false' ||
                      localStorage.isShowDoNotRefreshAndBack == 'undefined'
                    ) {
                      modalData.Title = _self.translate.instant('Common_lblInfo').toString();
                      modalData.Message = _self.translate.instant('Common_lblDoNotRefreshAndBack').toString();
                      modalData.Message1 = _self.translate.instant('Common_lblDoNotRefreshAndBackCheck').toString();
                      return _self.modal.open(DoNotRefreshAndBackComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                        obj.onDestroy.subscribe(data => {
                          localStorage.isShowDoNotRefreshAndBack = modalData.isShowDoNotRefreshAndBack;
                          _self.sendMoneyDetail = new SendMoneyDetail();
                          _self.sendMoneyDetail.isData = true;
                          _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                          _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                          _self.router.navigate(['/sendmoney']);
                          return;
                        });
                      });
                    } else {
                      _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                      _self.sendMoneyDetail = new SendMoneyDetail();
                      _self.sendMoneyDetail.isData = true;
                      _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                      _self.router.navigate(['/sendmoney']);
                      return;
                    }
                  }
                });
              });
            });
          });
        }
      },
      error => {}
    );
  }
  sendMoneyClick() {
    const _self = this;
    if (!___MobileAgent___.IsWrapper() && (localStorage.isShowDoNotRefreshAndBack == false || localStorage.isShowDoNotRefreshAndBack == undefined ||
      localStorage.isShowDoNotRefreshAndBack == 'false' || localStorage.isShowDoNotRefreshAndBack == 'undefined')) {
      let modalData: any = {};
      modalData.Title = this.translate.instant('Common_lblInfo').toString();
      modalData.Message = this.translate.instant('Common_lblDoNotRefreshAndBack').toString();
      modalData.Message1 = this.translate.instant('Common_lblDoNotRefreshAndBackCheck').toString();
      return this.modal.open(DoNotRefreshAndBackComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
        obj.onDestroy.subscribe(data => {
          localStorage.isShowDoNotRefreshAndBack = modalData.isShowDoNotRefreshAndBack;
          _self.utilserv.busy = _self.geoloc.islocPermissionable().subscribe(
            data => {
              if (data == undefined) {
                return;
              }
              if (data == true) {
                _self.sendMoneyDetail = new SendMoneyDetail();
                _self.sendMoneyDetail.isData = true;
                _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                _self.router.navigate(['/sendmoney']);
                return;
              } else {
                let modalData: any = {};
                modalData.Action = _self.translate.instant('Common_lblOk');
                modalData.Title = _self.translate.instant('Common_lblInfo').toString();
                modalData.Message = _self.translate.instant('Common_lblLocationValidate').toString();
                modalData.isLinkify=true;
                _self.modal.overlay.defaultViewContainer = _self.vcRef;
                return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
                  obj.onDestroy.subscribe(data => {
                    _self.sendMoneyDetail = new SendMoneyDetail();
                    _self.sendMoneyDetail.isData = true;
                    _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                    _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                    _self.router.navigate(['/sendmoney']);
                    return;
                  });
                });
              }
            },
            error => {}
          );
        });
      });
    } else {
      this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(
        data => {
          if (data == undefined) {
            return;
          }
          if (data == true) {
            _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
            _self.sendMoneyDetail = new SendMoneyDetail();
            _self.sendMoneyDetail.isData = true;
            _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
            _self.router.navigate(['/sendmoney']);
            return;
          } else {
            let modalData: any = {};
            modalData.Action = _self.translate.instant('Common_lblOk');
            modalData.Title = _self.translate.instant('Common_lblInfo').toString();
            modalData.Message = _self.translate.instant('Common_lblLocationValidate').toString();
            modalData.isLinkify=true;
            _self.modal.overlay.defaultViewContainer = _self.vcRef;
            return _self.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
              obj.onDestroy.subscribe(data => {
                _self.sendMoneyDetail = new SendMoneyDetail();
                _self.sendMoneyDetail.isData = true;
                _self.sendMoneyService.setSendMoneyDetailDataBlank(_self.sendMoneyDetail);
                _self.sendMoneyService.setModalPopup(SendMoneySteps.PickupType);
                _self.router.navigate(['/sendmoney']);
                return;
              });
            });
          }
        },
        error => {}
      );
    }
  }

  getcarttype(curcarddetailresponsemodel: currentcartdetail) {
    this.utilserv.busy = this.cartservice.getcarttypeservice().subscribe(
      data => {
        if (data.StatusCode == 20001) {
          return false;
        }
        if (data.StatusCode == enumStatusCodeList.SUCCESS) {
          curcarddetailresponsemodel.CartExpiry = this.utilserv.getObjectText(data.CartExpiry);
          curcarddetailresponsemodel.CustmerPaymentMethod = this.utilserv.getObjectText(data.CustmerPaymentMethod);
          // CustmerPaymentMethod-10,30 30-Debit card 10- Store
          curcarddetailresponsemodel.FundingId = this.utilserv.getObjectText(data.FundingId);
          curcarddetailresponsemodel.GuaranteedCancellationPeriod = this.utilserv.getObjectText(data.GuaranteedCancellationPeriod);
          curcarddetailresponsemodel.ItemCount = this.utilserv.getObjectText(data.ItemCount);
          curcarddetailresponsemodel.StoreId = this.utilserv.getObjectText(data.StoreId);
          curcarddetailresponsemodel.StoreName = this.utilserv.getObjectText(data.StoreName);
          curcarddetailresponsemodel.SuperSend = this.utilserv.getObjectText(data.SuperSend);
          curcarddetailresponsemodel.UnReadMessageCount = this.utilserv.getObjectText(data.UnReadMessageCount);
          this.cartservice.setcurrentcartDetailDashBoardData(curcarddetailresponsemodel);
          this.sendMoneyService.setcurrentcartDetailData(curcarddetailresponsemodel);
          // this.userDetails();
        }
      },
      error => {
        //console.log('Error');
      }
    );
  }

  initAppData() {
    sessionStorage.removeItem('benificaryData');
    sessionStorage.removeItem('RepeatOrderFlow');
    sessionStorage.removeItem('PageFlow');
    sessionStorage.removeItem('orderData');
    this.sendMoneyService.setModalPopup(0);
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyDetail.isData = false;
    this.sendMoneyService.setSendMoneyDetailDataBlank(this.sendMoneyDetail);
    let sendMoneyProgramDetail = new SendMoneyProgramDetail();
    sendMoneyProgramDetail.FromPage = 'default';
    this.sendMoneyService.setSendMoneyProgramDetailData(sendMoneyProgramDetail);
    this.sendMoneyService.setPageFlow('');
    this.sendMoneyService.setRepeatOrderFlow('');
    // this.sendMoneyService.resetAllData();
  }
  userDetails() {
    this.utilserv.busy = this.auth.getUserDetail().subscribe(
      data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          this.auth.setUserDetails(resJSON);
          sessionStorage.UserData = this.utilserv.AESEncrypt(JSON.stringify(resJSON));
        }
      },
      error => {
        //console.log('getting error' + error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/dash-board/dashboard-landingpage/dash-board.component.ts